export const DecoyEffect = {
    de: {
        title: "Mehr Auswahl – bessere Entscheidung?",
        description:
            "Du sitzt hungrig mit deinen Freund:innen im Burgerladen. Die Karte ist voll mit leckeren Optionen – und es geht nicht nur um den Burger! Auch bei den Pommes und dem Getränk musst du dich entscheiden: Was landet auf deinem Tablett?",
        screens: {
            fries1: {
                heading: "Pommes-Auswahl",
                // Optionen direkt im Kontext-Text ergänzt
                context: `Du bist mit ein paar Freundinnen und Freunden in einem Burgerladen. Ihr habt euch gerade euer Hauptgericht ausgesucht, da fragt euch die Bedienung:\n„Möchtest du noch Pommes zu deinem Burger?“\n\nEs gibt zwei Größen zur Auswahl:\n• Klein – 2,50 €\n• Groß – 4,50 €`,
                question: "Für welche Größe entscheidest du dich?",
                optionSmall: "Klein",
                optionLarge: "Groß",
                priceSmall: "2,50 €",
                priceLarge: "4,50 €",
                selectedSmall: "Du hast „Klein“ gewählt.",
                selectedLarge: "Du hast „Groß“ gewählt.",
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung an."
            },
            drink1: {
                heading: "Getränke-Auswahl",
                context: `Nachdem du dich für deine Pommes entschieden hast, fragt dich die Bedienung:\n„Und noch ein Getränk dazu?“\nDu wirfst einen Blick auf den rechten Teil des Menü-Schilds. Für die Getränke gibt es drei Größen zur Auswahl:`,
                list: [
                    "Small – 3,50 €",
                    "Medium – 6,00 €",
                    "Large – 6,50 €"
                ],
                question: "Für welche Größe entscheidest du dich?",
                optionSmall: "Small",
                optionMedium: "Medium",
                optionLarge: "Large",
                priceSmall: "3,50 €",
                priceMedium: "6,00 €",
                priceLarge: "6,50 €",
                selectedSmall: "Du hast „Small“ gewählt.",
                selectedMedium: "Du hast „Medium“ gewählt.",
                selectedLarge: "Du hast „Large“ gewählt.",
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung an."
            },
            fries2: {
                heading: "Pommes-Auswahl",
                context: `Du bist mit ein paar Freundinnen und Freunden in einem Burgerladen. Ihr habt euch gerade euer Hauptgericht ausgesucht, da fragt euch die Bedienung:\n„Möchtest du noch Pommes zu deinem Menü?“`,
                question: "Für welche Größe entscheidest du dich?",
                optionSmall: "Klein",
                optionMedium: "Mittel",
                optionLarge: "Groß",
                priceSmall: "2,50 €",
                priceMedium: "4,00 €",
                priceLarge: "4,50 €",
                selectedSmall: "Du hast „Klein“ gewählt.",
                selectedMedium: "Du hast „Mittel“ gewählt.",
                selectedLarge: "Du hast „Groß“ gewählt.",
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung an."
            },
            drink2: {
                heading: "Getränke-Auswahl",
                context: `Nachdem du dich für deine Pommes entschieden hast, fragt dich die Bedienung:\n„Und noch ein Getränk dazu?“\nDu siehst dir den rechten Teil des Menü-Schilds an. Für die Getränke gibt es zwei Optionen:`,
                list: [
                    "Small – 3,50 €",
                    "Large – 6,50 €"
                ],
                question: "Für welche Größe entscheidest du dich?",
                optionSmall: "Small",
                optionLarge: "Large",
                priceSmall: "3,50 €",
                priceLarge: "6,50 €",
                selectedSmall: "Du hast „Small“ gewählt.",
                selectedLarge: "Du hast „Large“ gewählt.",
                reasonLabel: "Bitte begründe deine Wahl:",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Bitte gib eine kurze Begründung an."
            },
            results: {
                loading: "Lade Ergebnisse…",
                headline: "Wie beeinflusst die zusätzliche Option die Auswahl?",
                group1Title: "Gruppe 1: Erst 2x 🍟, dann 3x 🥤 Optionen",
                group2Title: "Gruppe 2: Erst 3x 🍟, dann 2x 🥤 Optionen",
                pommesChoice: "Pommes-Auswahl",
                drinkChoice: "Getränke-Auswahl",
                yourGroup: "Du warst zufällig in <b>Gruppe {group}</b>{variant}. Deine Wahl: <b>{pommes}</b> Portion Pommes und <b>{drink}</b> Getränk.",
                group1Variant: " (2x 🍟, dann 3x 🥤)",
                group2Variant: " (3x 🍟, dann 2x 🥤)",
                noChoices: "Deine persönlichen Entscheidungen konnten nicht erkannt werden."
            },
            resultsRelative: {
                loading: "Lade Vergleich…",
                headline: "Wie beeinflusst die zusätzliche Option die Auswahl?",
                pommes: "Pommes:",
                drinks: "Getränke:",
                decoyLabel: "Mit Decoy",
                noDecoyLabel: "Ohne Decoy",
                pommesLegend: [
                    "Ohne Decoy (2x 🍟):",
                    "Mit Decoy (3x 🍟, „mittel“ ignoriert):"
                ],
                drinksLegend: [
                    "Ohne Decoy (2x 🥤):",
                    "Mit Decoy (3x 🥤, „mittel“ ignoriert):"
                ],
                ignoreMedium: "Die mittlere („Decoy“-)Option wird bei der Auswertung ignoriert.<br>So siehst du, wie das Hinzufügen einer Option die Entscheidung zwischen „klein“ und „groß“ beeinflusst!"
            },
            explanation: {
                headline: "Wie beeinflusst der Decoy-Effekt unsere Entscheidungen?",
                experimentNote: `<b>Wie war das in eurem Burger-Experiment?</b><br /><br />Ihr habt entweder bei den Getränken oder bei den Pommes mal zwei und mal drei Auswahlmöglichkeiten bekommen. Die Gruppe mit drei Wahlmöglichkeiten hatte jeweils eine Köder-Option.<br /><br />Das Besondere: Nicht alle hatten gleichzeitig einen Decoy, sondern nur bei einer von beiden Entscheidungen. So konnte man sehen, wie die zusätzliche, unattraktive Option eure Wahl beeinflusst hat, auch wenn sie kaum jemand genommen hat.<br /><br />Der Decoy-Effekt zeigt sich also darin, dass die Köder-Option eine andere Auswahl attraktiver macht, die sogar teurer sein kann!`,
                sections: [
                    {
                        title: "Was ist der Decoy-Effekt?",
                        paragraph: `Im Alltag treffen wir oft Entscheidungen zwischen mehreren Angeboten. Manchmal gibt es eine Auswahl, bei der eine Option sehr teuer oder wenig attraktiv wirkt. Durch diese Köder-Option wirkt ein anderes Angebot plötzlich viel besser. Das nennt man Decoy-Effekt. Unternehmen nutzen diesen Trick, damit wir uns eher für das Angebot entscheiden, das sie verkaufen wollen.`
                    },
                    {
                        title: "Wie wird dieser Effekt ausgenutzt?",
                        paragraph: `Stell dir vor, du möchtest etwas kaufen und bekommst drei Möglichkeiten: Eine günstige, eine teure und eine unattraktive, die etwas dazwischen liegt, aber eigentlich keinen Sinn ergibt. Die mittlere Option ist so gestaltet, dass sie das teure Angebot besser erscheinen lässt. Auch wenn fast niemand die mittlere wählt, hilft sie dabei, die teure Option beliebter zu machen. So beeinflussen Unternehmen unsere Entscheidung, ohne dass wir es merken.`
                    },
                    {
                        title: "Warum ist der Decoy-Effekt besonders?",
                        paragraph: `Eigentlich sagt eine wichtige Regel aus der Entscheidungstheorie, dass ein Angebot nicht plötzlich beliebter werden sollte, nur weil eine weitere Auswahl dazukommt. Und wenn ein ähnliches Produkt dazu kommt, sollte das ursprüngliche Angebot sogar weniger interessant werden. Beim Decoy-Effekt ist das anders: Die neue, unattraktive Option sorgt dafür, dass das gewünschte Angebot besonders gut dasteht.`
                    },
                    {
                        title: "Bekanntes Forschungsbeispiel",
                        paragraph: `Forscher haben gezeigt, wie das funktioniert: Bei einer Studie konnten Menschen zwischen zwei Kameras wählen, einer günstigen und einer teuren. Als eine dritte, unattraktive Kamera dazu kam, entschieden sich plötzlich mehr Leute für die teure Kamera. Die Köder-Option hat die Entscheidung also beeinflusst, obwohl sie kaum jemand wirklich gekauft hat.`
                    }
                ],
                sources: [
                    "Huber, J., Payne, J. W., & Puto, C. (1982). Adding asymmetrically dominated alternatives: Violations of regularity and the similarity hypothesis. Journal of Consumer Research, 9(1), 90–98.",
                    "Ariely, D. (2008). Predictably Irrational: The Hidden Forces That Shape Our Decisions. HarperCollins.",
                    "Rieskamp, J., Busemeyer, J. R., & Mellers, B. A. (2006). Extending the Bounds of Rationality: Evidence and Theories of Preferential Choice. Journal of Economic Literature, 44(3), 631–661."
                ]
            }
        }
    },
    en: {
        title: "More Options – Better Decision?",
        description:
            "You are sitting with your friends in a burger place, feeling hungry. The menu is full of delicious options – and it's not just about the burgers! You also have to decide about fries and a drink: What will end up on your tray?",
        screens: {
            fries1: {
                heading: "Fries Choice",
                // Added both options to context text
                context: `You and your friends are at a burger place. You’ve just chosen your main dish, when the server asks:\n“Would you like some fries with your burger?”\n\nThere are two sizes to choose from:\n• Small – €2.50\n• Large – €4.50`,
                question: "Which size do you choose?",
                optionSmall: "Small",
                optionLarge: "Large",
                priceSmall: "€2.50",
                priceLarge: "€4.50",
                selectedSmall: 'You chose "Small".',
                selectedLarge: 'You chose "Large".',
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            drink1: {
                heading: "Drink Choice",
                context: `After deciding on your fries, the server asks:\n“And a drink?”\nYou look at the right side of the menu board. For drinks, there are three sizes to choose from:`,
                list: [
                    "Small – €3.50",
                    "Medium – €6.00",
                    "Large – €6.50"
                ],
                question: "Which size do you choose?",
                optionSmall: "Small",
                optionMedium: "Medium",
                optionLarge: "Large",
                priceSmall: "€3.50",
                priceMedium: "€6.00",
                priceLarge: "€6.50",
                selectedSmall: 'You chose "Small".',
                selectedMedium: 'You chose "Medium".',
                selectedLarge: 'You chose "Large".',
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            fries2: {
                heading: "Fries Choice",
                context: `Imagine the following situation:\n\nYou are with some friends in a burger place. You’ve just chosen your main dish, when the server asks:\n“Would you like some fries with your menu?”`,
                question: "Which size do you choose?",
                optionSmall: "Small",
                optionMedium: "Medium",
                optionLarge: "Large",
                priceSmall: "€2.50",
                priceMedium: "€4.00",
                priceLarge: "€4.50",
                selectedSmall: 'You chose "Small".',
                selectedMedium: 'You chose "Medium".',
                selectedLarge: 'You chose "Large".',
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            drink2: {
                heading: "Drink Choice",
                context: `After deciding on your fries, the server asks:\n“And a drink?”\nYou look at the right side of the menu board. For drinks, there are two options:`,
                list: [
                    "Small – €3.50",
                    "Large – €6.50"
                ],
                question: "Which size do you choose?",
                optionSmall: "Small",
                optionLarge: "Large",
                priceSmall: "€3.50",
                priceLarge: "€6.50",
                selectedSmall: 'You chose "Small".',
                selectedLarge: 'You chose "Large".',
                reasonLabel: "Please explain your choice:",
                reasonRequired: "(required)",
                reasonPlaceholder: "Please enter a brief explanation."
            },
            results: {
                loading: "Loading results…",
                headline: "How does the additional option affect the choice?",
                group1Title: "Group 1: First 2x 🍟, then 3x 🥤 options",
                group2Title: "Group 2: First 3x 🍟, then 2x 🥤 options",
                pommesChoice: "Fries choice",
                drinkChoice: "Drink choice",
                yourGroup: "You were randomly in <b>Group {group}</b>{variant}. Your choice: <b>{pommes}</b> fries portion and <b>{drink}</b> drink.",
                group1Variant: " (2x 🍟, then 3x 🥤)",
                group2Variant: " (3x 🍟, then 2x 🥤)",
                noChoices: "Your individual choices could not be identified."
            },
            resultsRelative: {
                loading: "Loading comparison…",
                headline: "How does the additional option affect the choice?",
                pommes: "Fries:",
                drinks: "Drinks:",
                decoyLabel: "With decoy",
                noDecoyLabel: "No decoy",
                pommesLegend: [
                    "No decoy (2x 🍟):",
                    "With decoy (3x 🍟, ignoring \"medium\"):"
                ],
                drinksLegend: [
                    "No decoy (2x 🥤):",
                    "With decoy (3x 🥤, ignoring \"medium\"):"
                ],
                ignoreMedium: "The middle (“decoy”) option is being ignored in the analysis.<br>This shows how adding an option affects the decision between “small” and “large”!"
            },
            explanation: {
                headline: "How does the decoy effect influence our decisions?",
                experimentNote: `<b>What about your burger experiment?</b><br /><br />You either had two or three choices for drinks or fries. The group with three choices always had a decoy option.<br /><br />The special thing: Not everyone had a decoy at the same time, only for one of the choices. This made it possible to see how the additional unattractive option influenced your choice, even if hardly anyone chose it.<br /><br />The decoy effect is the fact that the decoy option makes another choice more attractive – even if it is more expensive!`,
                sections: [
                    {
                        title: "What is the decoy effect?",
                        paragraph: `In everyday life, we often make decisions between several offers. Sometimes there is a selection where one option seems very expensive or unattractive. This decoy option makes another offer suddenly look much better. That's called the decoy effect. Companies use this trick so that we are more likely to choose the offer they want to sell.`
                    },
                    {
                        title: "How is this effect exploited?",
                        paragraph: `Imagine you want to buy something and have three possibilities: a cheap one, an expensive one and an unattractive one in between, which doesn't really make sense. The middle option is designed to make the expensive offer look better. Even if almost no one chooses the middle one, it helps to make the expensive option more popular. This is how companies influence our decisions without us noticing.`
                    },
                    {
                        title: "Why is the decoy effect special?",
                        paragraph: `Actually, an important rule of decision theory says that an offer shouldn't suddenly become more popular just because another choice is added. And if a similar product is added, the original offer should even become less interesting. But with the decoy effect it's different: The new, unattractive option makes the desired offer look especially good.`
                    },
                    {
                        title: "Famous research example",
                        paragraph: `Researchers have shown how this works: In a study, people could choose between two cameras, a cheap one and an expensive one. When a third, unattractive camera was added, suddenly more people chose the expensive camera. The decoy option influenced the decision, even though hardly anyone actually bought it.`
                    }
                ],
                sources: [
                    "Huber, J., Payne, J. W., & Puto, C. (1982). Adding asymmetrically dominated alternatives: Violations of regularity and the similarity hypothesis. Journal of Consumer Research, 9(1), 90–98.",
                    "Ariely, D. (2008). Predictably Irrational: The Hidden Forces That Shape Our Decisions. HarperCollins.",
                    "Rieskamp, J., Busemeyer, J. R., & Mellers, B. A. (2006). Extending the Bounds of Rationality: Evidence and Theories of Preferential Choice. Journal of Economic Literature, 44(3), 631–661."
                ]
            }
        }
    }
};